var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanadianAlgorithmic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4961_57334)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.7281,
    y: 27.6238,
    width: 48.5437,
    height: 24.7525,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.194 27.6238H64.2718V52.3763H52.194V27.6238ZM31.29 40L30.5932 40.238C30.5932 40.238 34.774 43.8081 34.774 44.0461C35.0063 44.2841 35.2385 44.2841 35.0063 44.9981C34.774 45.7121 34.5417 46.4261 34.5417 46.4261C34.5417 46.4261 38.258 45.7121 38.7225 45.4741C39.1871 45.4741 39.4193 45.4741 39.4193 45.9501C39.4193 46.4261 39.1871 50.4722 39.1871 50.4722H40.3484C40.3484 50.4722 40.1161 46.1881 40.1161 45.9501C40.1161 45.4741 40.3484 45.4741 40.8129 45.4741C41.2775 45.4741 44.9937 46.4261 44.9937 46.4261C44.9937 46.4261 44.7615 45.4741 44.5292 44.9981C44.2969 44.2841 44.5292 44.2841 44.7614 44.0461C44.9937 43.8081 48.9422 40.238 48.9422 40.238L48.2454 40C47.7809 39.762 48.0132 39.524 48.0132 39.286C48.0132 39.048 48.71 36.668 48.71 36.668C48.71 36.668 46.8519 37.144 46.6196 37.144C46.3873 37.144 46.1551 37.144 46.1551 36.906C46.1551 36.668 45.6905 35.7159 45.6905 35.7159C45.6905 35.7159 43.6001 38.096 43.3679 38.334C42.9033 38.81 42.4388 38.334 42.6711 37.858C42.6711 37.382 43.8324 32.3839 43.8324 32.3839C43.8324 32.3839 42.6711 33.0979 42.2065 33.3359C41.742 33.5739 41.5097 33.5739 41.5097 33.0979C41.2775 32.6219 39.8839 30.0038 39.8839 29.7658C39.8839 29.7658 38.4902 32.6219 38.258 33.0979C38.0257 33.5739 37.7935 33.5739 37.5612 33.3359C37.0967 33.0979 35.9353 32.3839 35.9353 32.3839C35.9353 32.3839 37.0966 37.382 37.0966 37.858C37.0966 38.334 36.8644 38.572 36.3999 38.334L34.0772 35.7159C34.0772 35.7159 33.8449 36.4299 33.6127 36.668C33.6127 36.906 33.3804 37.144 33.1481 36.906C32.6836 36.906 30.8255 36.4299 30.8255 36.4299C30.8255 36.4299 31.5223 38.81 31.7545 39.048C31.7545 39.286 31.7545 39.762 31.29 40ZM15.7281 27.6238H27.806V52.3763H15.7281V27.6238Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4961_57334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.5437,
    height: 24.7525,
    fill: "white",
    transform: "translate(15.7281 27.6238)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanadianAlgorithmic);
export default __webpack_public_path__ + "static/media/canadian-algorithmic.4478e8d099dab7dcefd0c602294e6c4b.svg";
export { ForwardRef as ReactComponent };